var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0203 13.181L3.59251 12.3995L1.91092 7.20889L28.0203 13.181ZM28.0203 13.181L8.2273 24.433L5.60196 18.5912L4.46307 16.0524L28.0203 13.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0203 13.181L4.46306 16.0524L2.08779 18.9608L3.5925 12.3995L28.0203 13.181Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6019 18.5912L2.08774 18.9608L4.46301 16.0524L5.6019 18.5912Z",
    fill: "#BBBBCD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendImg);
export default __webpack_public_path__ + "static/media/send-img.cae2058834e94a3f3ae9bed91f0dd9d9.svg";
export { ForwardRef as ReactComponent };